// import { createStore, applyMiddleware, compose } from "redux";
// import createSagaMiddleware from "redux-saga";

// import rootReducer from "./reducers";
// import rootSaga from "./sagas";

// const sagaMiddleware = createSagaMiddleware();
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// const store = createStore(
//   rootReducer,
//   composeEnhancers(applyMiddleware(sagaMiddleware))
// );
// sagaMiddleware.run(rootSaga);

// export default store;

import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import createSagaMiddleware from "redux-saga";
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
import rootSaga from "./sagas";
import { priorityUkApi } from "../services/PriorityUkService";
import { priorityMoscowApi } from "../services/PriorityMoscowService";
import { priorityUAEApi } from "../services/PriorityUAEService";
import { priorityPLApi } from "../services/PriorityPLService";
import { leaveApi } from "../services/LeaveService";
import { logDelsApi } from "../services/LogisticFeeService";
import { ordersApi } from "../services/OrderService";
import { catalogApi } from "../services/CatalogService";
import { infoApi } from "../services/InfoService";
import { usersApi } from "../services/UsersService";
import { pricesApi } from "../services/PriceService";
import { marketingApi } from "../services/MarketingService";
import { notificationsApi } from "../services/NotificationsService";
import { transfersEuropeApi } from "../services/TransfersService";
import { calculatorApi } from "../services/CalculatorService";

const sagaMiddleware = createSagaMiddleware();
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false, // Enable immutable state check
      serializableCheck: false, // Disable serializability check if needed
    })
      .concat(priorityUkApi.middleware) // Add your RTK API middleware
      .concat(priorityMoscowApi.middleware) // Add your RTK API middleware
      .concat(priorityUAEApi.middleware) // Add your RTK API middleware
      .concat(priorityPLApi.middleware) // Add your RTK API middleware
      .concat(leaveApi.middleware) // Add your RTK API middleware
      .concat(logDelsApi.middleware) // Add your RTK API middleware
      .concat(ordersApi.middleware) // Add your RTK API middleware
      .concat(catalogApi.middleware) // Add your RTK API middleware
      .concat(infoApi.middleware) // Add your RTK API middleware
      .concat(usersApi.middleware) // Add your RTK API middleware
      .concat(pricesApi.middleware) // Add your RTK API middleware
      .concat(marketingApi.middleware) // Add your RTK API middleware
      .concat(notificationsApi.middleware) // Add your RTK API middleware
      .concat(transfersEuropeApi.middleware) // Add your RTK API middleware
      .concat(calculatorApi.middleware) // Add your RTK API middleware
      .concat(sagaMiddleware), // Add saga middleware
  devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools only in development
});

sagaMiddleware.run(rootSaga);

export default store;
